import $ from 'jquery';
import Backbone from 'backbone';
import ChartContainerView from '@/data/views/chart_container';

export default Backbone.View.extend({
  initialize: function() {
    this.containerEl = document.getElementById('widget-content');
    this.widgetContainerEl = document.getElementById('widget-chart-container');
    this.footerEl = document.getElementById('data_widget_footer');
    this.branded = this.containerEl.classList.contains('branded');

    this.model = window.chart;

    if (this.model) {
      this.render();
    }
  },
  render: function() {
    this.chart_container = new ChartContainerView({
      el: this.widgetContainerEl,
      model: this.model,
    });

    if (this.branded) {
      this.footerEl.hidden = false;
    }

    // make links in the chart description work in iframes
    $('#widget-chart-container .chart-description a').attr('target', '_parent');
  },
});
